import { render, staticRenderFns } from "./Popup.vue?vue&type=template&id=1a6355be&"
import script from "./Popup.vue?vue&type=script&lang=ts&"
export * from "./Popup.vue?vue&type=script&lang=ts&"
import style0 from "./Popup.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports